import { FileType } from 'components/DynamicDownload/interfaces';

import { base64ToBlob } from './base64ToBlob';
import { isBase64 } from './validations';

export const saveBlobAsLocalFile = (data: BlobPart, name: string, type: FileType) => {
  const formattedData = isBase64(data as string) ? base64ToBlob(data as string) : (data as Blob);

  const blob = new Blob([formattedData], { type });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = name;
  link.style.display = 'none';

  document.body.appendChild(link);

  link.addEventListener('click', function listener() {
    document.body.removeChild(link);
    link.removeEventListener('click', listener);
    setTimeout(() => window.URL.revokeObjectURL(url), 30000);
  });

  link.click();
};
